module.exports = __webpack_public_path__ + "static/media/check-background.6b604468.svg";